import Button from 'components/Button';
import css from './css.module.scss';
import clsx from 'clsx';

const Break = ({ language, t, sendDemoEvent, advertisingView, darkMode }) => (
    <section className={clsx(css['start-trial-break'], (advertisingView && darkMode) && css['dark-break'])}>

    <Button large onClick={sendDemoEvent} language={language}>
      {t('home.hero.button')}
    </Button>
  </section>
);

export default Break;